
import { BarChart3, TrendingUp, Zap } from "lucide-react";
import { useIntersectionObserver } from "../../hooks/useIntersectionObserver";
import AnimatedNumber from "../../components/AnimatedNumber";

const stats = [
  { number: 30, label: "Less Time Planning", icon: Zap },
  { number: 40, label: "Increased Forecast Accuracy", icon: TrendingUp },
  { number: 50, label: "Faster Decision-Making", icon: BarChart3 },
];

const StatsMetrics = () => {
  const [ref, isVisible] = useIntersectionObserver();

  return (
    <section className="py-4 md:py-6 px-4 md:px-6 bg-primary text-white">
      <div 
        ref={ref}
        className={`max-w-7xl mx-auto transition-all duration-1000 transform ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <div className="grid grid-cols-3 gap-3 md:gap-12 text-center">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <div 
                key={index} 
                className="space-y-2 md:space-y-4"
                style={{
                  transitionDelay: `${index * 200}ms`
                }}
              >
                <Icon className="w-8 h-8 md:w-12 md:h-12 mx-auto" style={{ color: '#27b5fc' }} />
                <div className="text-2xl md:text-4xl lg:text-5xl font-charter font-medium">
                  {isVisible && <AnimatedNumber end={stat.number} prefix="" duration={2000} />}%
                </div>
                <div className="text-accent text-xs md:text-base">{stat.label}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default StatsMetrics;
